module.exports = __webpack_public_path__ + "static/media/accolades.16e4f60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/accolades.png
// module id = 48
// module chunks = 0